var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgHeartFull = function SvgSvgHeartFull(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.628 23.313a.747.747 0 0 0 .979.003c5.258-4.503 13.455-13.523 10.83-18.768a6.414 6.414 0 0 0-1.201-1.666A6.377 6.377 0 0 0 17.694 1a6.373 6.373 0 0 0-4.539 1.88l-1.036 1.035-1.036-1.035a6.382 6.382 0 0 0-1.67-1.204A6.359 6.359 0 0 0 6.546.995c-.689 0-1.375.112-2.037.333A6.377 6.377 0 0 0 .796 4.549C-.451 7.043.501 10.483 3.624 14.776c2.835 3.897 6.542 7.269 8.004 8.537Z",
    fill: "#EE2762"
  })));
};
export default SvgSvgHeartFull;